import FilterRating from './FilterRating';

export default FilterRating;
